import {
  ChatWidgetText,
  isSafeWidgetUrl,
  PaymentIssueWidget,
} from "../../../Helper/ChatWidget";
import { CardIcon } from "../ChatWidgetIcons";
import {
  Button,
  Card,
  ChatWidgetAnswer,
  Foot,
  openWidgetUrl,
  Receipt,
} from "../ChatWidgetPrimitives";
import "./PaymentIssueCard.scss";

/**
 * 09 Payment issue: the failed payment, the decline reason and the fix.
 * Retry only shows when the billing tool can run it (`canRetry`).
 */
export const PaymentIssueCard = ({
  widget,
  onAnswer,
  text,
}: {
  widget: PaymentIssueWidget;
  onAnswer: ChatWidgetAnswer;
  text: ChatWidgetText;
}) => {
  const meta = [widget.date, widget.method].filter(Boolean).join(" · ");
  if (widget.response) {
    return (
      <Receipt
        title={text("widgetRetryRequested")}
        detail={[widget.amount, widget.method].filter(Boolean).join(" · ")}
      />
    );
  }
  const title = widget.title ?? text("widgetPaymentFailed");
  const hasUpdate = isSafeWidgetUrl(widget.updateUrl);
  return (
    <Card className="cw-pay" label={title}>
      <div className="cw-pad cw-pay-head">
        <span className="cw-tile cw-tone--danger" aria-hidden="true">
          <CardIcon size={20} />
        </span>
        <div className="cw-stack cw-grow">
          <div className="cw-row">
            <span className="cw-h">{title}</span>
            <span className="cw-num cw-strong">{widget.amount}</span>
          </div>
          {meta && <span className="cw-muted cw-sm cw-num">{meta}</span>}
          {widget.reason && (
            <span className="cw-sm cw-body cw-pay-reason">{widget.reason}</span>
          )}
        </div>
      </div>
      {(widget.canRetry || hasUpdate) && (
        <Foot flush>
          {widget.canRetry && (
            <Button
              variant="ghost"
              onClick={() => onAnswer("confirm", {}, text("widgetRetryNow"))}
            >
              {text("widgetRetryNow")}
            </Button>
          )}
          {hasUpdate && (
            <Button onClick={() => openWidgetUrl(widget.updateUrl)}>
              {text("widgetUpdateCard")}
            </Button>
          )}
        </Foot>
      )}
    </Card>
  );
};
